$.fn.isInViewport = function () {
	const elementTop = $(this).offset().top;
	const elementBottom = elementTop + $(this).outerHeight();

	const viewportTop = $(window).scrollTop();
	const viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

$.cachedScript = function (url, options) {
	// Allow user to set any option except for dataType, cache, and url
	options = $.extend(options || {}, {
		dataType: 'script',
		cache: true,
		url: url
	});

	// Use $.ajax() since it is more flexible than $.getScript
	// Return the jqXHR object so we can chain callbacks
	return $.ajax(options);
};

